{
  "payoffs": "Pagos hipotecarios",
  "search-lender-label": "Buscar Prestamista de Pago Existente",
  "search-lender-action-label": "Agregar Nuevo Prestamista Global",
  "search-employee-label": "Buscar Empleados Existentes",
  "search-employee-action-label": "Agregar Nuevo Empleado",
  "lender-company-label": "Compañía Prestamista",
  "company-name-label": "Nombre de Empresa",
  "address-label": "Dirección",
  "employee-label": "Empleado",
  "associate_name_label": "Nombre del Asociado",
  "selected_lender_phone_number": "Número de teléfono",
  "selected_lender_address": "Dirección principal",
  "selected_lender_mailing_address": "Dirección de envio",
  "selected_lender_employee_name": "Nombre del empleado",
  "selected_lender_job_title": "Título prfesional",
  "selected_lender_email": "Email",
  "selected_lender_work_phone": "Télefono del trabajo",
  "selected_lender_cellphone": "Télefono móvil",
  "selected_lender_change_button": "Cambiar Prestamista",
  "payoff_information": "Información de Pago",
  "recording_information": "Registro de Información",
  "loan": "Préstamo #",
  "mortgagor_snn": "Deudor SNN",
  "current_lien_holder": "Titular Actual del Gravamen",
  "original_mortgagee": "Acreedor Hipotecario Original",
  "original_mortgagee_amount": "Monto Original del Acreedor Hipotecario",
  "date_mortgagee": "Fecha del Acreedor Hipotecario",
  "date_recorded": "Fecha de Registro",
  "instrument": "Instrumento #",
  "book": "Libro",
  "page": "Página",
  "cert_of_title": "Certificado de título #",
  "doc": "Doc #",
  "line-items": "Artículos de Línea",
  "principal": "Principal",
  "interest": "Interés",
  "to": "To",
  "through": "Through",
  "additional-interest": "Interés Adicional",
  "additional-interest-title": "Configuración de Línea de Interés Adicional",
  "additional-interest-subtitle": "Intereses adicionales adeudados en la forma de liquidación desde la fecha “calculada hasta” hasta la fecha “válida hasta”.",
  "interest-calculated": "Intereses Calculados",
  "from": "From",
  "interest-rate": "Tasa de Interés",
  "per-diem": "Por día",
  "escrow": "Depósito",
  "prepay-charge": "Cargo por Prepago",
  "late-charge": "Ultima carga",
  "additional-line": "Línea adicional",
  "type-here": "Escriba aquí...",
  "total-due": "Total Adeudado",
  "lender-name": "Nombre del Prestamista",
  "payment-amount": "Monto del Pago",
  "reference": "Referencia #",
  "routing": "Enrutamiento #",
  "bank-name": "Nombre del Banco",
  "account": "Cuenta #",
  "account-name": "Nombre de la Cuenta",
  "further-credit-to": "Crédito Adicional a",
  "order-number": "Orden #",
  "for-benefit-of": "En Beneficio de",
  "borrower": "Prestamista",
  "settlement-agency": "Agencia de Liquidación",
  "none": "Ninguno",
  "payments": "Pagos",
  "payment": "Pago",
  "lender-selected": "Prestador Selected",
  "delete-mortage": "Eliminar hipoteca",
  "loan-information": "Información del préstamo",
  "property-selected": "Propiedad seleccionada",
  "add-new-party": "Agregar Nueva Partida",
  "add-payoff": "Agregar pago",
  "add": "Agregar",
  "payoff": "Pago",
  "save-charges-prompt": "Presiona guardar para registrar tus cargos",
  "no-changes": "No hay cambios para guardar",
  "deed-date": "Fecha de escritura",
  "recission-date": "Fecha de rescisión",
  "recorded-date": "Fecha de registro",
  "certificate-title": "título del certificado",
  "document-number": "Numero de Documento",
  "instrument-number": "Número de instrumento",
  "additional": "Adicional",
  "prepay": "Prepago",
  "late": "Atrasado",
  "add-new-line-item": "Agregar nuevo ítem",
  "not-payoffs": "No hay liquidación actualmente seleccionada",
  "create-one-payoff": "por favor seleccione o cree una",
  "add-new-mortgage": "Agregar pago hipotecario",
  "party-added-success": "Parte agregada exitosamente",
  "loading": "Cargando...",
  "principal-amount": "Monto Principal: {{amount}}",
  "success-party-added": "Parte agregada exitosamente",
  "success-party-deleted": "Parte eliminada exitosamente",
  "no-parties-added": "No hay partes agregadas",
  "success-deleted": "Eliminado exitosamente",
  "delete-payoff": "Eliminar pago",
  "delete-payoff-confirmation": "¿Está seguro de que desea eliminar el pago de la hipoteca?",
  "original-mortgage-amount": "Monto original de la hipoteca",
  "loan-number-if-known": "Número de préstamo (si se conoce)",
  "none-property": "Ninguna",
  "loan-unknown": "Pago #(desconocido)",
  "delete-line-item": "Eliminar partida",
  "delete-line-item-confirmation": "¿Está seguro de que desea eliminar la partida \"{{name}}\"?",
  "delete-party": "Eliminar parte",
  "delete-party-confirmation": "¿Está seguro de que desea quitar a {{name}} como {{kind}} de este pago?",
  "delete-party-kind": "Quitar {{kind}}",
  "mortgage-created": "Pago de hipoteca creado",
  "saving": "Guardando..."
}
